import { Switch } from "react-router-dom";
import ContratosServico from "../../pages/contratos/contratoservico";
import Route from "../Route";

export const Contratos = () => (
  <Switch>
    <Route path="/contratos/servico" component={ContratosServico} />
  </Switch>
);
